// Shared pagination layout constants. Purity: constants (side-effect free).
export const PAGE_HEIGHT = 1056;
export const PAGE_DIVIDER_HEIGHT = 15;
export const PAGE_STRIDE = PAGE_HEIGHT + PAGE_DIVIDER_HEIGHT;
export const PORTRAIT_PAGE_WIDTH = 816;
export const PORTRAIT_PAGE_HEIGHT = PAGE_HEIGHT;
export const LANDSCAPE_PAGE_WIDTH = PORTRAIT_PAGE_HEIGHT;
export const LANDSCAPE_PAGE_HEIGHT = PORTRAIT_PAGE_WIDTH;

// Suppress zoom/sub-pixel jitter from triggering extra page flips/reflows.
export const PAGINATION_REFLOW_EPSILON_PX = 1;
export const PAGE_INDEX_EPSILON_PX = 1;
export const DEFAULT_PAGE_MARGIN = 46;

export const PAGE_BREAK_CLASS = 'page-break';
export const PAGE_BREAK_SELECTOR = `.${PAGE_BREAK_CLASS}`;
export const PAGE_BREAK_TOP_CLASS = 'page-break-top';
export const PAGE_BREAK_BOTTOM_CLASS = 'page-break-bottom';
export const PAGE_BREAK_TOP_SELECTOR = `.${PAGE_BREAK_TOP_CLASS}`;
export const PAGE_BREAK_BOTTOM_SELECTOR = `.${PAGE_BREAK_BOTTOM_CLASS}`;
export const PAGE_BREAK_PAGE_INDEX_ATTR = 'data-page-index';
export const PAGE_BREAK_WITH_PAGE_INDEX_SELECTOR = `${PAGE_BREAK_SELECTOR}[${PAGE_BREAK_PAGE_INDEX_ATTR}]`;
